<template>
	<div>
		<a-modal title="绑定项目" :width="480" :visible="visible"  @cancel="handleCancel" >
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
				<a-button  key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					确定绑定
				</a-button>
			</template>
			<div>
				<a-spin :spinning="loading">
					<div class="flex center">
						<a-input-search placeholder="搜索项目名称" style="width: 420px" @search="onSearch" v-model="search.name" />
					</div>
					
					<div class="mt16">
						<div class="flex center wrap">
							<template v-for="(item,index) in datas">
								<div class="bind-project-item" v-if="select_ids.indexOf(item.project_id)!=-1" >
									<div class="flex space ">
										<div class="flex">
											<img  :src="item.cover_img"/>
											
											<div class="ml10">
												<div class="text-over4 ft14 ftw400 cl-black">{{item.abbreviation}} </div>
												<div class="mt10 ft12 ftw400 cl-notice text-over4">门市原价：¥{{item.market_price}}</div>
											</div>
										</div>
										
										<div class="flex alcenter" >
											<div class="bind-project-item-selected" @click="removeSelectId(index)">
												<a-icon type="check" class="cl-w"/>
											</div>
										</div>
									</div>
								</div>
								
								<div class="bind-project-item " v-else>
									<div class="flex space ">
										<div class="flex">
											<img  :src="item.cover_img"/>
											
											<div class="ml10">
												<div class="text-over4 ft14 ftw400 cl-black">{{item.abbreviation}} </div>
												<div class="mt10 ft12 ftw400 cl-notice text-over4">门市原价：¥{{item.market_price}}</div>
											</div>
										</div>
										
										<div  class="flex alcenter" >
											<div class="bind-project-item-select" @click="addSelectId(index)">
												
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
					
					<div class="flex center mt20">
						<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current" :pageSize="pagination.pageSize" show-less-items />
					</div>
				</a-spin>
				
			</div>
		</a-modal>
	</div>
</template>

<script>
	import {listMixin} from '../../../../../../common/mixin/list.js';
	export default {
		mixins:[listMixin],
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			technician_id:{
				type:Number,
				default:0,
			}
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				pagination: {
					current: 1,
					pageSize: 4, //每页中显示10条数据
					total: 0,
				},
				search:{
					project_id:'',
				},
				select_ids:[],
				datas:[],
			}
		},
		methods: {
			
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getProjectListFromTechnicianBind',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					technician_id:this.technician_id,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			onSearch(){
				this.pagination.current=1;
				this.getLists();
			},
			
			/**
			 * 选中
			 * @param {Object} index
			 */
			addSelectId(index) {
				if (this.select_ids.indexOf(this.datas[index].project_id) != -1) {
					this.$message.error("您已经选择过这个了");
				}
				this.select_ids.push(this.datas[index].project_id);
			},
			
			/**
			 * 取消选择
			 * @param {Object} index
			 */
			removeSelectId(index) {
				let startIndex = this.select_ids.indexOf(this.datas[index].project_id);
				if (startIndex == -1) {
					this.$message.error("您已经取消过这个了");
				}
				this.select_ids.splice(startIndex, 1);
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
	
			/**
			 * 提交数据
			 */
			onSubmit() {
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/technicianBindProject',{
					technician_id:this.technician_id,
					project_ids:this.select_ids,
				}).then(res=>{
					this.$message.success('成功绑定',1,()=>{
						this.confirmLoading=false;
						this.$emit('ok');
					})
					
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
			
		}
	}
</script>

<style>
	
	.bind-project-item{
		width: 420px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		margin-bottom: 10px;
		padding: 10px;
	}
	
	.bind-project-item img{
		width: 75px;
		height: 60px;
	}
	
	.bind-project-item-select{
		width: 24px;
		height: 24px;
		border-radius: 4px;
		border: 2px solid #A6AEC2;
		cursor: pointer;
	}
	
	.bind-project-item-selected{
		width: 24px;
		height: 24px;
		background: #4772FF;
		line-height: 24px;
		text-align: center;
	}
</style>
